import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { CommonService } from "../../../../services/common.service";
import { AppConfig } from "../../../../configs/app";
import { AuthService } from "../../../../services/auth.service";
import { ReservationService } from "../../../../services/reservation.service";
import { PlanService } from "../../../../services/plan.service";
import { CacheService } from "../../../../services/cache.service";
import { UserService } from "../../../../services/user.service";

declare var Cleave: any;

@Component({
  selector: "page-reserve-index",
  templateUrl: "./index.component.html",
})
export class PageReserveIndexComponent implements OnInit {
  public postData: any = {};
  public divisionData: any = [];
  public formGroup: FormGroup;
  public showingAge: any;
  public testMail: any = {
    email1: {
      errorMessage: "",
      hasError: false,
      successMessage: "",
    },
    email2: {
      errorMessage: "",
      hasError: false,
      successMessage: "",
    },
  };

  /* CUSTOM VALIDATOR */
  public myValidator: any = {};

  public $: any;
  public _: any;
  public moment: any;

  /* NEW MEMBER CHECK DATA */
  public emailNUsernameCheckData: any = {
    email: {
      data: "",
      hasError: false,
      errorMessage: "",
      successMessage: "",
    },
    username: {
      data: "",
      hasError: false,
      errorMessage: "",
      successMessage: "",
    },
    isChecking: false,
  };

  /* FOR TEMPORARY ASSIGNING */
  public tempData: any = {};

  constructor(
    public formBuilder: FormBuilder,
    public commonService: CommonService,
    public appConfig: AppConfig,
    public authService: AuthService,
    public reservationService: ReservationService,
    public planService: PlanService,
    public cacheService: CacheService,
    public userService: UserService
  ) {
    let self = this;
    this.$ = this.commonService.getJQuery();
    this._ = this.commonService.getLodash();
    this.moment = this.commonService.getMoment();

    /* CUSTOM VALIDATOR */
    this.myValidator.isNumeric = function (control: AbstractControl): any {
      if (
        control.value &&
        control.value != "" &&
        !self.commonService.isNumeric(control.value)
      ) {
        return { isNumeric: true };
      }
      return null;
    };

    this.myValidator.isKana = function (control: AbstractControl): any {
      if (!self.commonService.isKana(control.value)) {
        return { isKana: true };
      }
      return null;
    };

    this.myValidator.newMemberRequired = function (
      control: AbstractControl
    ): any {
      if (
        !self.authService.isLoggedIn() &&
        self.postData.bookingWithRegistering ==
          self.appConfig.reservation.registerWithBookingOn
      ) {
        if (control.value && control.value != "") {
          /* DO NOTHING */
        } else {
          return { required: true };
        }
      }
      return null;
    };

    this.myValidator.validDate = function (inputName: string = "") {
      return function (control: AbstractControl): any {
        let value = control.value.toString().replace(/[/]/g, "");
        if (value.length < 8) {
          return { validDate: true };
        }
        if (self.moment(value, "YYYYMMDD", true).isValid() !== true) {
          return { validDate: true };
        }
        return null;
      };
    };

    this.myValidator.isRomanAlphabetNNumber = function (
      control: AbstractControl
    ): any {
      if (!self.commonService.isRomanAlphabetNNumber(control.value)) {
        return { isRomanAlphabetNNumber: true };
      }
      return null;
    };
    /* END */
  }

  async ngOnInit() {
    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* INITIALIZE FORM DATA */
    this.initFormGroup();

    /* GET DIVISION DATA */
    this.divisionData = await this.planService.getDivisions();
    delete this.divisionData.division_root[0];
    /* END */

    /* EXECUTE INLINE JAVASCRIPT */
    this.inlineJS();

    /* HIDE LOADER */
    this.commonService.hidePageLoader();
  }

  /* INITIALIZE FORM DATA */
  initFormGroup() {
    this.postData = this.reservationService.getReservationData();

    /* CHECK IF HAS DATA */
    if (this._.isEmpty(this.postData)) {
      return this.commonService.redirectToRoute(
        this.commonService.routePaths.pagePlanList
      );
    }

    this.tempData.formSubmitted = false;

    this.formGroup = this.formBuilder.group({
      c_mei: [
        this.postData.c_mei,
        [Validators.required, this.myValidator.isKana],
      ],
      c_sei: [
        this.postData.c_sei,
        [Validators.required, this.myValidator.isKana],
      ],
      c_sex: [this.postData.c_sex, Validators.required],
      c_coty_id: [this.postData.c_coty_id, Validators.required],
      c_birthday: [
        this.postData.c_birthday
          ? this.moment(this.postData.c_birthday, "YYYYMMDD").format("YYYYMMDD")
          : "",
        [Validators.required, this.myValidator.validDate()],
      ],
      c_tel: [
        this.postData.c_tel,
        [
          Validators.required,
          this.myValidator.isNumeric,
          Validators.minLength(10),
          Validators.maxLength(11),
        ],
      ],
      c_mail: [this.postData.c_mail, [Validators.required, Validators.email]],
      c_mail2: [this.postData.c_mail2, [Validators.email]],
      c_username: [
        this.postData.c_username ? this.postData.c_username : "",
        [
          this.myValidator.newMemberRequired,
          Validators.minLength(6),
          this.myValidator.isRomanAlphabetNNumber,
        ],
      ],
      c_password: [
        this.postData.c_password ? this.postData.c_password : "",
        [
          this.myValidator.newMemberRequired,
          Validators.minLength(7),
          this.myValidator.isRomanAlphabetNNumber,
        ],
      ],
    });

    /* SET AGE */
    this.showingAge = this.moment().diff(
      this.formGroup.controls.c_birthday.value,
      "years"
    );
  }

  async onSubmit() {
    this.tempData.formSubmitted = true;

    /* CHECK USERNAME & EMAIL AGAIN */
    this.emailNUsernameCheckData.isChecking = true;

    /* FORM ZEN TO HAN */
    this.commonService.convertFormInputZenToHan(this.formGroup);
    this.formValidationInit();

    if (
      this.postData.bookingWithRegistering ==
      this.appConfig.reservation.withoutRegisterOn
    ) {
      await this.checkEmailNUsername(
        "email",
        this.formGroup.controls["c_mail"].value
      );
      await this.checkEmailNUsername(
        "username",
        this.formGroup.controls["c_username"].value
      );
    }

    this.emailNUsernameCheckData.isChecking = false;
    /* END */

    if (
      this.formGroup.invalid ||
      this.emailNUsernameCheckData.isChecking ||
      this.emailNUsernameCheckData.email.hasError ||
      this.emailNUsernameCheckData.username.hasError
    ) {
      /* SCROLL TO THE FIRST ERROR FORM */
      if (this.$(".form-error-msg:visible").length !== 0) {
        this.$("html, body").animate(
          {
            scrollTop:
              this.$(".form-error-msg:visible").first().offset().top - 90,
          },
          200
        );
      }

      return false;
    }

    this.proceedToReservePassenger();
  }

  setFormValue(event: any, inputName: string) {
    this.formGroup.controls[inputName].setValue(event.target.value);
    if (
      inputName == "c_birthday" &&
      event.target.value.length == 10 &&
      this.moment(event.target.value, "YYYY/MM/DD", true).isValid() === true
    ) {
      this.showingAge = this.moment().diff(event.target.value, "years");
    } else {
      this.showingAge = null;
    }
  }
  /* END */

  proceedToReservePassenger() {
    /* PREPAIR TEL & BIRTHDAY */
    let tel = (document.querySelector("#tel") as HTMLInputElement).value;
    let birthday = (document.querySelector("#birthday") as HTMLInputElement)
      .value;
    this.formGroup.value.c_tel = tel;
    let telParts = this.commonService.getBBTelParts(this.formGroup.value.c_tel);
    this.formGroup.value.c_tel1 = telParts[0];
    this.formGroup.value.c_tel2 = telParts[1];
    this.formGroup.value.c_tel3 = telParts[2];
    this.formGroup.value.c_birthday = birthday.replace(/[/]/g, "");
    this.postData["1_p_birth_date_1"] = this.formGroup.value.c_birthday;
    this.postData["1_p_age_1"] = this.moment().diff(
      this.formGroup.value.c_birthday,
      "years"
    );
    this.postData["1_p_sei_1"] = this.formGroup.value.c_sei;
    this.postData["1_p_mei_1"] = this.formGroup.value.c_mei;
    this.postData["1_p_sex_1"] = this.formGroup.value.c_sex;
    this.postData["1_p_tel1_1"] = this.formGroup.value.c_tel1;
    this.postData["1_p_tel2_1"] = this.formGroup.value.c_tel2;
    this.postData["1_p_tel3_1"] = this.formGroup.value.c_tel3;
    this.postData["1_p_tel_1"] = tel;
    /* END */

    /* REFILL DATA */
    Object.assign(this.postData, this.formGroup.value);

    /* SAVE DATA */
    this.reservationService.saveReservationData(this.postData);

    /* GO TO NEXT PAGE */
    this.commonService.redirectToRoute(
      this.commonService.routePaths.pageReservePassengerPlan1NoParam
    );
  }

  async checkEmailNUsername(type: any, value: any) {
    this.testMail.email1.data = value;
    this.emailNUsernameCheckData.isChecking = true;

    if (
      type &&
      value &&
      this.postData.bookingWithRegistering ==
        this.appConfig.reservation.withoutRegisterOn
    ) {
      if (["email", "username"].indexOf(type) !== -1) {
        /* PRE CHECK */
        switch (type) {
          case "email":
            if (this.formGroup.controls.c_mail.errors) {
              this.emailNUsernameCheckData.isChecking = false;
              return false;
            }
            break;

          case "username":
            if (this.formGroup.controls.c_username.errors) {
              this.emailNUsernameCheckData.isChecking = false;
              return false;
            }
            break;
        }

        /* API CHECK */
        let data = {
          type: type,
          checking_data: value,
        };

        let returnedData = await this.userService.existChecking(data);

        switch (type) {
          case "email":
            if (returnedData.status == "success") {
              this.emailNUsernameCheckData.email.hasError = false;
              this.emailNUsernameCheckData.email.successMessage = "success";
            } else {
              this.emailNUsernameCheckData.email.hasError = true;
              this.emailNUsernameCheckData.email.errorMessage =
                returnedData.message;
              this.emailNUsernameCheckData.email.successMessage = null;
            }
            break;

          case "username":
            if (returnedData.status == "success") {
              this.emailNUsernameCheckData.username.hasError = false;
              this.emailNUsernameCheckData.username.successMessage = "success";
            } else {
              this.emailNUsernameCheckData.username.hasError = true;
              this.emailNUsernameCheckData.username.errorMessage =
                returnedData.message;
              this.emailNUsernameCheckData.username.successMessage = null;
            }
            break;
        }
      } else {
        this.emailNUsernameCheckData.email.hasError = true;
        this.emailNUsernameCheckData.email.errorMessage =
          "reservation.error.newEmail";
        this.emailNUsernameCheckData.username.hasError = true;
        this.emailNUsernameCheckData.username.errorMessage =
          "reservation.error.newUsername";
      }
    }

    this.emailNUsernameCheckData.isChecking = false;
  }

  setEmail2(value: any) {
    this.testMail.email2.data = value;
  }

  async sendTestMail(type: any) {
    switch (type) {
      case "email1":
        let returnedData = await this.authService.sendTestMail(
          this.testMail.email1.data
        );
        if (returnedData.status == "fail") {
          this.testMail.email1.hasError = true;
          this.testMail.email1.successMessage = "";
          this.testMail.email1.errorMessage = returnedData.data;
        } else {
          this.testMail.email1.hasError = false;
          this.testMail.email1.successMessage = "reservation.error.emailSent";
          this.testMail.email1.errorMessage = "";
        }
        break;

      case "email2":
        let returnedData1 = await this.authService.sendTestMail(
          this.testMail.email2.data
        );
        if (returnedData1.status == "fail") {
          this.testMail.email2.hasError = true;
          this.testMail.email2.successMessage = "";
          this.testMail.email2.errorMessage = returnedData1.data;
        } else {
          this.testMail.email2.hasError = false;
          this.testMail.email2.successMessage = "reservation.error.emailSent";
          this.testMail.email2.errorMessage = "";
        }
        break;
    }
  }

  inlineJS() {
    let self = this;
    this.$(function () {
      self.formValidationInit();

      /* INIT INPUT ZEN TO HAN */
      self.commonService.zenToHan();
    });
  }

  formValidationInit() {
    new Cleave(".js-birthday", {
      delimiter: "/",
      blocks: [4, 2, 2],
    });
  }
}
